import React, { useState } from "react";
import { useStaticQuery, graphql } from "gatsby";
import GravityFormForm from "../GravityForm";
import { EbookFormSection, FormHeading } from "./CaresPhase1eBookDownloadStyle";

const CaresPhase4eBookDownload = ({ Subtitle }: any) => {
  const [showTitle, setShowTitle] = useState(true);
  const data = useStaticQuery(graphql`
    query CaresPhase4eBookDownload {
      tsGfForm(databaseId: { eq: 36 }) {
        ...GravityFormFields
      }
      ts {
        gfSettings {
          recaptcha {
            publicKey
            type
          }
        }
      }
    }
  `);
  const onSuccess = () => {
    setShowTitle(false);
  };
  return (
    <EbookFormSection>
      {showTitle && (
        <>
          <FormHeading className="heading">Get Your eBook Today!</FormHeading>
          <p className="subtitle">
            {Subtitle
              ? Subtitle
              : "To know how to meet staff demands and capability crunch"}
          </p>
          <p className="formtitle">Fill the details below:</p>
        </>
      )}
      <GravityFormForm data={data} successCallback={onSuccess} />
    </EbookFormSection>
  );
};

export default CaresPhase4eBookDownload;
